import React from "react";
import { Col, Row } from "reactstrap";
import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";
import { CPRelayTest } from "../../CP/NewCrossingReport/CombinedForms";
import { relayReport } from "../../CP/NewCrossingReport/ReportSections/relayReport";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportFraInfoSectionContainer from "../../../../libraries/ReportGenerator/ReportFraInfoSection";
import ReportFraConditionsMasterKey from "../../../../libraries/ReportGenerator/ReportFraConditionsMasterKey";

const relayCodes = [
  { key: "OK", value: "Test complete equipment in satisfactory condition" },
  { key: "A/C", value: "Adjustments made / Test complete ‐ equipment in satisfactory condition" },
  { key: "R/C", value: "Repair or replacement / Test complete ‐ equipment in satisfactory condition" },
  { key: "N/A", value: "Test Not Applicable" },
];

function showEmptyColumn() {
  return <Col md={12}>{<div className="comments-text info-section"> </div>}</Col>;
}

const RelayReportView = (props) => {
  let { data } = props;

  return (
    <div className="mainContent table-report RelayTestInspectionCP last-page-break-print" style={{ minHeight: "800px" }}>
      {/* Report Header Section */}
      <Row>
        <Col md={4}>{<ReportTitleSection {...props} fontSizeOverride={"30px"} />}</Col>
        <Col md={8}>
          <h1 style={{ fontWeight: "900", marginTop: "15px" }}>Inspection Report - Relay Tests and Inspections</h1>
        </Col>
      </Row>

      {showEmptyColumn()}
      <ReportFraInfoSectionContainer {...props} />
      {showEmptyColumn()}
      <ReportFraConditionsMasterKey masterKey={relayCodes} />
      {showEmptyColumn()}
      <p> </p>
      <Col md={12}>
        <Row>
          {relayReport(data.decodedData || [])}
          {showEmptyColumn()}
        </Row>
      </Col>
    </div>
  );
};

const RelayReportsView = (props) => {
  let { reportData } = props;

  let reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(reportData);
  let relayReportData = ReportGroupingUtils.filterReportsByTestCodes(
    reportsByDateAndUser,
    CPRelayTest.map((cp) => cp.code),
  );
  let relayDecodedData = ReportGroupingUtils.decodeTestsInReportGroups(
    relayReportData,
    CPRelayTest.map((cp) => cp.code),
  );
  relayDecodedData = relayDecodedData.filter((data) => data.reports.length > 0);
  return relayDecodedData.map((report, i) => <RelayReportView key={i} {...props} data={report} />);
};

export default RelayReportsView;



// WEBPACK FOOTER //
// ./src/components/Reports/sims/ontario/RelayReportsView.jsx